import { render, staticRenderFns } from "./OrderDetailCellRenderer.vue?vue&type=template&id=1c005006&"
import script from "./OrderDetailCellRenderer.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports